import { PerformanceIcon } from '@components/icons/PerformanceIcon'
import { DecimalFormat } from '@components/shared/Format'
import { GoldCard } from '@components/shared/GoldCard'
import { I18n } from '@components/shared/I18n'
import { InfoBar } from '@components/shared/InfoBar'
import { Table, TableCell, TableRow } from '@components/shared/Table'
import { WithTooltip } from '@components/shared/WithTooltip'
import { CountryInfoUrlKey } from '@models/CountryInfo'
import { SectionComponent } from '@sections/SectionComponent'
import { StoreProps } from '@stores/Store'
import { I18nKey } from '@utils/i18n'
import { inject, observer } from 'mobx-react'
import React from 'react'

@inject('store')
@observer
export class PerformanceIncentivesSection extends SectionComponent<StoreProps, {}> {
  static defaultProps = {} as StoreProps
  static get title(): I18nKey { return 'SECTION_PERFORMANCE_INCENTIVES' }
  static get icon() { return <PerformanceIcon /> }
  static get trackerKey() { return 'C+performance' }

  render() {
    const { store } = this.props
    const { performanceAnnualAmount, personalPVValue, performanceMinRubyPV } = store.performanceIncentiveCalculation
    return (
      <>
        <InfoBar>
          <WithTooltip title='PERFORMANCE_INCENTIVES_TOOLTIP' iconPosition='right'><I18n name='PERFORMANCE_INCENTIVES' /></WithTooltip>
        </InfoBar>
        <Table>
          <TableRow header>
            <TableCell><I18n name='PERSONAL_PV_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={personalPVValue} /></TableCell>
          </TableRow>
          <TableRow>
            <TableCell><I18n name='PERFORMANCE_PERCENT_REQUIREMENT' /></TableCell>
            <TableCell align='right'><DecimalFormat value={performanceMinRubyPV} />&nbsp;<I18n name='RUBY_PV' /></TableCell>
          </TableRow>
        </Table>
        <div className='section section-rewards'>
          {performanceAnnualAmount === 0 ? (
            <GoldCard title='CP_PERFORMANCE_INCENTIVE_DISABLED' disabled
              infoContent={undefined}
              infoUrl={CountryInfoUrlKey.INFO_PERFORMANCE_PLUS_INCENTIVE_URL}></GoldCard>
          ) : (
            <GoldCard title='CP_PERFORMANCE_INCENTIVE' value={performanceAnnualAmount} period='PER_YEAR'></GoldCard>
          )}
        </div>
      </>
    )
  }
}
